import styled from 'styled-components';

export const StyledFooter = styled.footer`
  min-height: 8vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
  padding: var(--space-6) var(--space-4);
  text-align: center;
  background-color: var(--c-surface);
  border-top: var(--border);

  .logo__svg {
    width: 40px;
    height: 40px;
  }

  .logo__svg path {
    fill: var(--c-text-muted);
    transition: fill 0.2s ease;
  }

  .logo:hover .logo__svg path {
    fill: var(--c-accent);
  }

  .navigation {
    display: flex;
    gap: var(--space-3);
  }

  p {
    font-size: var(--fs-sm);
    color: var(--c-text-subtle);
  }

  .nick {
    color: var(--c-text-muted);
    font-weight: var(--fw-bold);
  }

  @media (min-width: 786px) {
    flex-direction: row;
    justify-content: space-between;
    padding: var(--space-6) var(--space-8);
    text-align: left;
  }
`;
